import InviteToGroupModal from './InviteToGroupModal';
import InviteToGroupModalContainer from './InviteToGroupModal.container';

import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import InviteToGroupModalV2 from '../InviteToGroupModal.gruser_backroom';

export default withFeatureBranch({
  gruser_backroom: InviteToGroupModalV2,
})(InviteToGroupModalContainer(InviteToGroupModal));
